import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getClinicUsage} from './getClinicUsage';

export const clinicUsageQueryOptions = (clinicId: string, from: string, to: string) =>
  queryOptions({
    queryKey: keys.usage.clinic(clinicId, from, to),
    queryFn: () => getClinicUsage(clinicId, from, to),
    enabled: clinicId !== '',
  });
